import { gql } from '@apollo/client';

export default gql`
  query Features {
    features {
      id
      name
      type
    }
  }
`;
